"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Bell = function Bell(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M5.681 15.54a1.563 1.563 0 001.168-1.436l.547-4.607a4.604 4.604 0 013.372-3.886 1.243 1.243 0 012.47 0 4.605 4.605 0 013.372 3.886l.548 4.606a1.563 1.563 0 001.168 1.438.746.746 0 01-.203 1.465H5.883a.746.746 0 01-.202-1.465zm6.322 3.967a1.88 1.88 0 01-1.877-1.711.156.156 0 01.158-.165h3.438a.156.156 0 01.158.165 1.88 1.88 0 01-1.877 1.71z"
  }));
};

var _default = (0, _react.forwardRef)(Bell);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Bell, "Bell", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Bell.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Bell.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9CZWxsLnRzeCJdLCJuYW1lcyI6WyJCZWxsIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLElBQW9FLEdBQUcsU0FBdkVBLElBQXVFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzNFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLElBQUksRUFBQyxjQURQO0FBRUUsSUFBQSxDQUFDLEVBQUM7QUFGSixJQURGLENBRDJFO0FBQUEsQ0FBN0U7O2VBU2UsdUJBQVdGLElBQVgsQzs7Ozs7Ozs7Ozs7OzswQkFUVEEsSSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQmVsbDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNNS42ODEgMTUuNTRhMS41NjMgMS41NjMgMCAwMDEuMTY4LTEuNDM2bC41NDctNC42MDdhNC42MDQgNC42MDQgMCAwMTMuMzcyLTMuODg2IDEuMjQzIDEuMjQzIDAgMDEyLjQ3IDAgNC42MDUgNC42MDUgMCAwMTMuMzcyIDMuODg2bC41NDggNC42MDZhMS41NjMgMS41NjMgMCAwMDEuMTY4IDEuNDM4Ljc0Ni43NDYgMCAwMS0uMjAzIDEuNDY1SDUuODgzYS43NDYuNzQ2IDAgMDEtLjIwMi0xLjQ2NXptNi4zMjIgMy45NjdhMS44OCAxLjg4IDAgMDEtMS44NzctMS43MTEuMTU2LjE1NiAwIDAxLjE1OC0uMTY1aDMuNDM4YS4xNTYuMTU2IDAgMDEuMTU4LjE2NSAxLjg4IDEuODggMCAwMS0xLjg3NyAxLjcxelwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKEJlbGwpO1xuIl19